import { CurrenciesContext } from '@/currencies/currency.context';
import { useWallets } from '@/devtools/hooks/useWallets.hook';
import BigNumber from 'bignumber.js';
import { useContext, useState } from 'react';
import { GetWalletsByAssetResponseWalletsItem } from '@utx/utx-client';

export interface WalletsByAccountLabelItem extends GetWalletsByAssetResponseWalletsItem {
  asset: string;
  decimals: number;
}

export interface WalletsByAccountLabel extends Array<WalletsByAccountLabelItem> {}

interface UseAccountSelectorNativeParams {
  asset?: any;
  otherSelectedId?: string;
  subaccountFlag?: boolean;
  balanceAllFlag?: boolean;
}

export const useAccountSelectorNative = ({ asset, otherSelectedId, subaccountFlag, balanceAllFlag }: UseAccountSelectorNativeParams) => {
  const { currenciesDict } = useContext(CurrenciesContext);
  const [searchText, setSearchText] = useState('');

  const walletsQuery = useWallets({ enabled: true, noSave: true, search: searchText });
  const wallets = walletsQuery.wallets.data?.data ?? [];
  const isLoading = walletsQuery.wallets.isLoading;
  // Sort by Array<wallets>.Array<wallets>.acountLabel
  const tempWallets: WalletsByAccountLabel = wallets.reduce((acc, wallet) => {
    if (asset && ((typeof asset == 'string' && wallet.asset !== asset) || (asset instanceof Array && !asset.includes(wallet.asset))))
      return acc;
    let assetWallets: WalletsByAccountLabel = [];
    wallet.wallets.forEach((item) => {
      if (!balanceAllFlag && new BigNumber(item.balance).lte(0)) return;
      if (!item.accountLabel && !item.accountName) return;
      if (item.accountLabel && subaccountFlag) return;
      if (otherSelectedId && item.id == otherSelectedId) return;

      const decimals = currenciesDict?.[wallet.asset]?.display_decimal
        ? new BigNumber(currenciesDict[wallet.asset].display_decimal).toNumber()
        : 2;

      assetWallets.push({
        ...item,
        asset: wallet.asset,
        decimals
      });
    });
    return [...acc, ...assetWallets];
  }, [] as WalletsByAccountLabel);

  const walletsSortByAccountLabel = tempWallets.sort((a, b) => {
    if (!a.accountLabel || !b.accountLabel) return 0;

    const aAccountLabel = a.accountLabel || a.accountName;
    const bAccountLabel = b.accountLabel || a.accountName;

    const accountLabels = ['wallet_jurisdiction_hk', 'wallet_jurisdiction_us', 'wallet_jurisdiction_sg', 'wallet_digital'];
    for (let i = 0; i < accountLabels.length; i++) {
      if (aAccountLabel.toLowerCase().includes(accountLabels[i])) {
        return -1;
      }
      if (bAccountLabel.toLowerCase().includes(accountLabels[i])) {
        return 1;
      }
    }

    if (aAccountLabel.localeCompare(bAccountLabel) < 0) {
      return 1;
    }
    if (aAccountLabel.localeCompare(bAccountLabel) > 0) {
      return -1;
    }
    return 0;
  });

  const displayWallets = walletsSortByAccountLabel;

  const handleChangeSearchText = (text: string) => {
    setSearchText(text);
  };

  return {
    searchText,
    displayWallets,
    walletsSortByAccountLabel,
    handleChangeSearchText,
    isLoading
  };
};
